var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "form-group d-flex text-md",
    },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "290",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                {
                  staticClass: "text-h6 text-center",
                },
                [_vm._v("\n        " + _vm._s(_vm.dialog_message) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "green darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), (_vm.deldigit = false)
                        },
                      },
                    },
                    [_vm._v("\n          ยกเลิก\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red darken-1",
                        text: "",
                      },
                      on: {
                        click: function ($event) {
                          ;(_vm.dialog = false), _vm.specialButtonDel()
                        },
                      },
                    },
                    [_vm._v("\n          ยืนยัน\n        ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-25 mx-1",
        },
        [
          _c(
            "span",
            {
              staticClass:
                "form-control text-success text-monospace px-1 text-center",
            },
            [_vm._v("\n      " + _vm._s(_vm.item.digits) + "\n    ")]
          ),
          _vm._v(" "),
          _c("input", {
            attrs: {
              required: "",
              type: "hidden",
              name: "type",
            },
            domProps: {
              value: _vm.item.type,
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-25 mx-1",
        },
        [
          _c(
            "div",
            {
              staticClass: "input-group-append input-group-joined",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.item.amount,
                    expression: "item.amount",
                  },
                ],
                staticClass:
                  "form-control text-monospace px-1 text-center text-black",
                attrs: {
                  required: "",
                  type: "tel",
                  name: "amount",
                  disabled: _vm.gameMasterSlug.startsWith("step_"),
                },
                domProps: {
                  value: _vm.item.amount,
                },
                on: {
                  paste: function ($event) {
                    return _vm.onPaste($event)
                  },
                  keypress: function ($event) {
                    return _vm.validateNumber($event)
                  },
                  input: function ($event) {
                    if ($event.target.composing) return

                    _vm.$set(_vm.item, "amount", $event.target.value)
                  },
                },
              }),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "w-50 d-flex",
        },
        [
          _vm.item.type != "4upper"
            ? _c(
                "span",
                {
                  staticClass:
                    "form-control text-success text-monospace px-1 text-center",
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        Intl.NumberFormat({
                          style: "currency",
                          currency: "THB",
                        }).format(_vm.item.amount * _vm.item.paybaht)
                      ) +
                      "\n    "
                  ),
                ]
              )
            : _c(
                "span",
                {
                  staticClass:
                    "form-control text-success text-monospace px-1 text-center",
                },
                [_vm._v("\n      1 ชุด\n    ")]
              ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass:
                "bg-primary px-2 text-white w-25 rounded-right d-flex align-items-center justify-content-center btn",
              on: {
                click: function ($event) {
                  return _vm.handleDelete($event)
                },
              },
            },
            [
              _c("i", {
                staticClass: "far fa-trash-alt",
              }),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }